
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experiences/interest/[...id]",
      function () {
        return require("private-next-pages/experiences/interest/[...id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experiences/interest/[...id]"])
      });
    }
  